module.exports = __webpack_public_path__ + "img/logo-buscador.36575a3c.png";